const MIN_PASSWORD_LENGTH = 8;

/** Check minimum password length (8 chars, matching hers consultation web flow). */
export function isValidPassword(password: string): boolean {
  return typeof password === "string" && password.length >= MIN_PASSWORD_LENGTH;
}

export type PasswordStrength = {
  /** 0 = empty, 1 = weak, 2 = fair, 3 = good, 4 = strong */
  strength: number;
  label: string;
  color: string;
};

/** Score password strength based on character diversity (matching hers mobile visual indicators). */
export function getPasswordStrength(password: string): PasswordStrength {
  if (!password) return { strength: 0, label: "", color: "" };

  let score = 0;
  if (password.length >= 8) score++;
  if (/[a-z]/.test(password)) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score++;

  if (score <= 2) return { strength: 1, label: "Weak", color: "text-red-400" };
  if (score === 3) return { strength: 2, label: "Fair", color: "text-yellow-400" };
  if (score === 4) return { strength: 3, label: "Good", color: "text-green-400" };
  return { strength: 4, label: "Strong", color: "text-green-400" };
}
